<template>
  <b-modal centered id="app-update-modal" title="ClarityNOW Update" hide-footer>
    <p class="text-center"><strong>A new version of ClarityNOW is available!</strong></p>
    <b-button block variant="success" @click="onClick">Refresh <i class="fas fa-refresh"></i></b-button>
  </b-modal>
</template>

<script>
export default {
  methods: {
    onClick() {
      window.localStorage.removeItem('version-update-needed');
      window.location.reload();
    }
  }
};
</script>